/**
 * Our globals context
 *
 * @author David Faber
 * @copyright (c) Peritus Webdesign GmbH
 */
import React from 'react';

export default React.createContext({});
